"use client";
import { useState, useEffect } from "react";
import { Accordion, AccordionHeader, AccordionBody } from "@material-tailwind/react";
import { useGenerator } from "@/app/context/GeneratorContext";
import BatchToggle from "./batchToggle";

const batchSizes = [1, 2, 3, 4];

export default function BatchToggleSet({ translations }: { translations: any }) {
  const { state, batchSize, setBatchSize } = useGenerator();
  const [open, setOpen] = useState(0);

  const handleOpen = (value: any) => {
    setOpen(open === value ? 0 : value);
  };

  // @ts-ignore
  function Icon({ id, open }) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
      </svg>
    );
  }

  useEffect(() => {
    if (state.queueType !== 1 && batchSize > 1) {
      setBatchSize(1);
    }
  }, [state.queueType]);

  return (
    <Accordion
      open={open === 1}
      icon={<Icon id={1} open={open} />}
      className="border-t-[0.5px] border-[#3C3C3C] bg-[#2B2D31] px-2 pt-2 md:px-4"
    >
      <AccordionHeader
        onClick={() => handleOpen(1)}
        className={`border-b-0 px-[4px] pb-4 pt-2 text-sm text-white sm:px-0 ${
          open === 1 ? "text-white hover:!text-white" : ""
        }`}
      >
        {translations.batchSize}
      </AccordionHeader>
      <AccordionBody className="pb-2 pt-0 text-base font-normal">
        {batchSizes.map((size) => (
          <BatchToggle key={size} batchValue={size} />
        ))}
        <div className="mt-4 text-sm text-white">{translations.batchTurboOnly}</div>
      </AccordionBody>
    </Accordion>
  );
}
